import React from "react";
import { ChatsIcon, XIcon } from "@phosphor-icons/react";
import "styles/panel/feedback.panel.css";

const FeedbackPanel = ({ onClose }) => {
  return (
    <div className="FeedbackPanel light">
      <div className="flex space row">
        <p className="xlarge">Feedback</p>
        <div className="icon large" onClick={onClose}>
          <XIcon size={20} />
        </div>

        </div>


        <p className="large">Chats</p>
        <p className="medium feedback-description">
          This feature is currently in development. Check back soon.
        </p>
      </div>

  );
};

export default FeedbackPanel;
